import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const Panel = ({
  children,
  alignment = 'right',
  context = null,
  triggers,
  defaultOpen = false,
  additionalClasses = '',
  isProductSizeGuide,
}) => {
  const { openTriggerEl, closeTriggerEl, toggleEl } = triggers;
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const handleOpenEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
  };
  const handleToggleEvent = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (openTriggerEl) {
      document.addEventListener('click', function (e) {
        if (e.target.hasAttribute(openTriggerEl)) {
          handleOpenEvent(e);
        }
      });
    }

    if (closeTriggerEl) {
      document.addEventListener('click', function (e) {
        if (e.target.hasAttribute(closeTriggerEl)) {
          handleCloseEvent(e);
        }
        if (e.target.classList.contains('cart__overlay')) {
          handleCloseEvent(e);
        }
      });
    }

    if (toggleEl) {
      document.addEventListener('click', function (e) {
        if (e.target.hasAttribute(toggleEl)) {
          handleToggleEvent(e);
        }
      });
    }

    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      // // if (openTriggerEl)
      // //   openTriggerEl.removeEventListener('click', handleOpenEvent);
      // // if (closeTriggerEl)
      // //   closeTriggerEl.removeEventListener('click', handleCloseEvent);
      // if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
  }, [openTriggerEl, closeTriggerEl, toggleEl]);

  useEffect(() => {
    const body = document.querySelector('body');

    if (isOpen) {
      if (!isProductSizeGuide)
        document
          .querySelector('[data-mini-cart-close]')
          .classList.remove('hidden');
      body.classList.add('cart__overlay');
    } else {
      if (!isProductSizeGuide)
        document
          .querySelector('[data-mini-cart-close]')
          .classList.add('hidden');
      body.classList.remove('cart__overlay');
    }
  }, [isOpen]);

  const closedClass =
    alignment === 'right' ? 'translate-x-full' : '-translate-x-full';

  const promoBanner = document.querySelector('.promo-bar')
  const miniCartOverlap = promoBanner ? true : null

  return (
    <div
      className={`block panelFlyout ${
        isProductSizeGuide
          ? 'w-full overflow-auto lg:w-[500px]'
          : 'w-[304px] lg:w-[341px]'
      } fixed bottom-0 transition-transform bg-white z-[10000000] ${
        alignment === 'right' ? 'right-0' : 'left-0'
      } ${isOpen ? 'translate-x-0' : closedClass} ${additionalClasses}
      ${
        miniCartOverlap
          ? 'h-[calc(100%)] h-[calc(100dvh-35px)] lg:top-0 lg:h-[100%] lg:h-[100vh]'
          : 'top-0 h-[100%] h-[100dvh] lg:h-[100vh]'
      }
      `}
    >
      {children}
    </div>
  );
};

export default Panel;
